/* **************************************************************************
 *
 * File contians custom components that override components in react-select
 * Have a look at the documentation for more information on customisation
 * https://react-select.com/components
 *
 * Its not always clear which component is for what, this is a list of those used here
 *
 * Option:          Internal wrapper around the options in the drop down list.
 * ValueContainer:  Internal wrapper around the selected value Select Component
 *
 ************************************************************************** */
import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
const containerStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
};
export function TwoColumnOption(props) {
    return (React.createElement(components.Option, { ...props },
        React.createElement("div", { style: containerStyles },
            React.createElement("strong", { style: { minWidth: '30%', textAlign: 'left' } }, props.label[0]),
            React.createElement("span", { style: { minWidth: '70%', textAlign: 'left' } }, props.label[1]))));
}
TwoColumnOption.propTypes = {
    label: PropTypes.array.isRequired,
};
export function TwoColumnValueContainer(props) {
    if (!props.selectProps.value)
        return React.createElement(components.ValueContainer, { ...props });
    return (React.createElement(components.ValueContainer, { ...props },
        React.createElement("div", { style: containerStyles },
            React.createElement("div", { style: { minWidth: '30%', textAlign: 'left' } },
                React.createElement("strong", null, props.selectProps.value.label[0])),
            React.createElement("div", { style: { minWidth: '70%', textAlign: 'left' } }, props.selectProps.value.label[1]))));
}
TwoColumnValueContainer.propTypes = {
    selectProps: PropTypes.object,
};
//# sourceMappingURL=TwoColumnList.js.map